import { MetaData } from "../../../../domains/models/document";
import { Checkbox, Form, Input, Select,DatePicker } from "antd";
import AddTags from "../../tags/add-tags";
import React from "react";
import { mapMetaDataToFormField } from "./document-utils";
import TextArea from "antd/es/input/TextArea";

export function buildFormElements (metaData: MetaData[]){
    const form = mapMetaDataToFormField(metaData)

    return form.map((item, index) => {
        const type = item.type.toLowerCase();

        switch (type) {
            case  'string'  :
                if (item.name === 'tag') {
                    return (
                        <Form.Item
                            key={index}
                            label={item.label}
                            className={'meta-form__input'}
                            // required={item.required}
                            name={item.name}
                        >
                            <AddTags
                                tagLabel={'Add Tags'}
                            />
                        </Form.Item>
                    )
                } else if (item.name !== 'description') {
                    return (
                        <Form.Item
                            key={index}
                            label={item.label}
                            className={'meta-form__input'}
                            // required={item.required}
                            name={item.name}
                        >
                            <Input/>
                        </Form.Item>

                    );
                } else {
                    return (
                        <Form.Item
                            key={index}
                            label={item.label}
                            className={'meta-form__input-textarea'}
                            // required={item.required}
                            name={item.name}
                        >
                            <TextArea/>
                        </Form.Item>

                    );
                }

            case 'number' :
                return (
                    <Form.Item
                        key={index}
                        label={item.label}
                        className={'meta-form__input-number'}
                        // required={item.required}
                        name={item.name}
                    >
                        <Input type={'number'}/>
                    </Form.Item>

                )
            case 'boolean' :
                return (
                    <Form.Item
                        key={index}
                        label={item.label}
                        valuePropName="checked"
                        className={'meta-form__input-number'}
                        name={item.name}
                        // required={item.required}
                    >
                        <Checkbox/>
                    </Form.Item>

                )
            case 'date'  :
                return (
                    <Form.Item
                        key={index}
                        label={item.label}
                        className={"meta-form__date-picker"}
                        name={item.name}
                        // required={item.required}
                    >
                        <DatePicker/>
                    </Form.Item>

                )
            case  'enum'  :
                return (
                    <Form.Item
                        key={index}
                        label={item.label}
                        className={"meta-form__select"}
                        name={item.name}
                        // required={item.required}
                    >
                        <Select
                            // options={props.options}
                        />
                    </Form.Item>

                )

            default:
                return (
                    <div key={index}>

                    </div>
                )
        }
    });
}
